/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Abandon_TitleInputs */



/**
* | output |
* | --- |
* | "Force Abandon VEKN ID?" |
*
* @param {Vekn_Abandon_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_abandon_title = /** @type {((inputs?: Vekn_Abandon_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Abandon_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Forcer l'abandon du VEKN ID ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Forzar abandono de ID VEKN?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Forçar Abandono do VEKN ID?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Forzare Abbandono VEKN ID?")
	return /** @type {LocalizedString} */ ("Force Abandon VEKN ID?")
});